import hasAttr from '../../../general/attr/hasAttr';

import exLanguage from '../../../language';
import * as exElement from '../../../utils/element';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function text(ctx: Context): any {
    ctx.shared.elements.text = {};

    function init(): void {
        create();
    }

    // ------------------------------------------------------------------------

    function create(): void {
        // Create element (select text)
        const elSelectText = exElement.create({
            merge: ctx.shared.config.text,
            class: {
                new: 'select-text',
            },
            dataset: {
                bsToggle: 'dropdown',
            },
        });
        ctx.shared.elements.element.appendChild(elSelectText);
        ctx.shared.elements.text.element = elSelectText;

        // Create event (show dropdown)
        elSelectText.addEventListener('show.bs.dropdown', function (evt): any {
            // If there is disabled
            if (hasAttr(getTextElement(), 'disabled')) {
                evt.preventDefault();
            }
            //
            else {
                getTextElement().focus();
            }
        });

        // --------------------------------------------------------------------

        // Create element (text)
        const elText = exElement.create({
            class: {
                new: 'form-select',
            },
            attr: {
                tabindex: '0',
            },
            html: ctx.shared.config.placeholder ?? exLanguage.line('select.no_selected'),
        });
        elSelectText.appendChild(elText);
        ctx.shared.elements.text.input = elText;

        elText.addEventListener('mousedown', function (evt): any {
            // If there is disabled
            if (hasAttr(getTextElement(), 'disabled')) {
                evt.preventDefault();
            }
        });

        // --------------------------------------------------------------------

        // If using disabled
        if (ctx.shared.config.disabled === true) {
            elText.setAttribute('disabled', '');
        }
    }

    // ------------------------------------------------------------------------

    function getElement(): HTMLElement {
        return ctx.shared.elements.text.element;
    }

    function getTextElement(): HTMLElement {
        return ctx.shared.elements.text.input;
    }

    function setValue(value: string): void {
        getTextElement().innerHTML = value;
    }

    function clearValue(): void {
        getTextElement().innerHTML = '';
    }

    // ------------------------------------------------------------------------

    return {
        init,
        create,
        getElement,
        getTextElement,
        setValue,
        clearValue,
    };
}

// ----------------------------------------------------------------------------

export default text;
